import { render, staticRenderFns } from "./examenv2.vue?vue&type=template&id=f5fb0cc6&"
import script from "./examenv2.vue?vue&type=script&lang=js&"
export * from "./examenv2.vue?vue&type=script&lang=js&"
import style0 from "./examenv2.vue?vue&type=style&index=0&id=f5fb0cc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports